import React from 'react';
import { ShieldCheck, FileText, ArrowsClockwise, Key, Certificate, Lock, Quotes } from '@phosphor-icons/react';
const stats = [{
  value: '10+',
  unit: 'years',
  label: 'Operating since 2014'
}, {
  value: '100%',
  unit: '',
  label: 'Australian-owned'
}, {
  value: '8+',
  unit: 'industries',
  label: 'Retail, hospitality, fuel, more'
}, {
  value: 'IPA',
  unit: '',
  label: 'Recognised supervision'
}, {
  value: 'E8',
  unit: 'aligned',
  label: 'ACSC Essential Eight'
}, {
  value: '5 / 52',
  unit: '',
  label: 'Support, weeks of the year'
}];
const securityItems = [{
  icon: ShieldCheck,
  title: 'Essential Eight aligned',
  desc: 'Australian Cyber Security Centre framework.'
}, {
  icon: FileText,
  title: 'Confidentiality agreement',
  desc: 'Signed before any data is shared.'
}, {
  icon: ArrowsClockwise,
  title: 'Daily backups',
  desc: 'Geo-redundant Australian-region storage.'
}, {
  icon: Key,
  title: 'You control payments',
  desc: 'We prepare, you authorise.'
}, {
  icon: Certificate,
  title: 'IPA-supervised',
  desc: 'Professional standards on every engagement.'
}, {
  icon: Lock,
  title: 'Secure cloud stack',
  desc: 'Microsoft 365, Xero AU, MYOB AU.'
}];
export function TrustBlock() {
  return <section id="trust" className="py-16 lg:py-24 bg-white" data-id="element-432">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-433">
        <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-434">
          <p className="font-mono text-[11px] tracking-wider uppercase text-knight-orange mb-3" data-id="element-435">
            Why hand your books to us
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-charcoal leading-tight" data-id="element-436">
            Australian-owned, IPA-supervised, real people on the line.
          </h2>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 border border-hairline rounded-md overflow-hidden divide-x divide-y md:divide-y-0 divide-hairline mb-16 stagger-children" data-id="element-437">
          {stats.map((s, i) => <div key={i} className="p-6 bg-white" data-id="element-438">
              <div className="flex items-baseline gap-1.5 mb-2" data-id="element-439">
                <span className="font-mono text-3xl font-semibold text-charcoal leading-none" data-id="element-440">
                  {s.value}
                </span>
                {s.unit && <span className="font-mono text-[10px] text-knight-orange uppercase tracking-wider" data-id="element-441">
                    {s.unit}
                  </span>}
              </div>
              <p className="text-xs text-gray-600 leading-relaxed" data-id="element-442">{s.label}</p>
            </div>)}
        </div>

        {/* Founder Block */}
        <div className="max-w-4xl mx-auto bg-off-white rounded-md border border-hairline p-8 lg:p-12 mb-16 flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-10 relative overflow-hidden" data-id="element-443">
          <div className="flex-shrink-0 relative" data-id="element-444">
            <img src="https://cdn.magicpatterns.com/uploads/6Jxe5Mqey23X4eNReXMsvo/Shaun_Bist.jpg" alt="Shaun Bist, Founder of Knight CFO, Bookkeeping and Payroll" className="w-28 h-28 md:w-36 md:h-36 rounded-full object-cover ring-1 ring-hairline" data-id="element-445" />
            <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:bottom-2 md:right-2 w-6 h-6 rounded-full bg-knight-orange flex items-center justify-center ring-2 ring-off-white" data-id="element-446">
              <Certificate size={12} weight="bold" className="text-white" data-id="element-447" />
            </div>
          </div>
          <div className="text-center md:text-left flex-grow" data-id="element-448">
            <p className="font-mono text-[10px] text-knight-orange uppercase tracking-wider mb-2" data-id="element-449">
              Founder
            </p>
            <h3 className="text-2xl lg:text-3xl font-heading font-bold text-charcoal mb-5" data-id="element-450">
              Shaun Bist
            </h3>
            <div className="relative" data-id="element-451">
              <Quotes size={20} weight="fill" className="text-knight-orange/30 absolute -top-1 -left-1 hidden md:block" data-id="element-452" />
              <p className="text-base lg:text-lg text-charcoal leading-relaxed md:pl-7" data-id="element-453">
                Knight is run by people you can actually talk to. When you call,
                you reach a real team, supervised to IPA standards, not an
                offshore call centre.
              </p>
            </div>
          </div>
        </div>

        {/* Security Strip */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10 stagger-children" data-id="element-454">
          {securityItems.map((item, i) => <div key={i} className="flex items-start gap-3 p-5 rounded-md border border-hairline bg-white hover:border-knight-orange/30 transition-colors duration-500 ease-out-expo" data-id="element-455">
              <div className="w-9 h-9 rounded-md bg-off-white border border-hairline flex items-center justify-center flex-shrink-0" data-id="element-456">
                <item.icon size={18} weight="duotone" className="text-knight-orange" data-id="element-457" />
              </div>
              <div className="flex-grow min-w-0" data-id="element-458">
                <h4 className="text-sm font-bold text-charcoal mb-1 leading-tight" data-id="element-459">
                  {item.title}
                </h4>
                <p className="text-xs text-gray-500 leading-relaxed" data-id="element-460">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>

        <p className="text-center text-[11px] text-gray-500 font-mono uppercase tracking-wider" data-id="element-461">
          / Real numbers. Real founder. No fabricated metrics.
        </p>
      </div>
    </section>;
}